import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import LimitItem from './LimitItem';

export default function ListLimits({ title, limits, loading }) {
  return (
    <Stack
      direction="column"
      gap={{ xs: '12px', md: '24px' }}
    >
      <Text
        color="primary"
        size="xl"
      >
        {title}
      </Text>
      <Stack gap={{ xs: '12px', md: '24px' }}>
        {limits.map((limit) => (
          <LimitItem
            description={limit.description}
            key={limit.title}
            loading={loading}
            src={limit.src}
            title={limit.title}
          />
        ))}
      </Stack>
    </Stack>
  );
}

ListLimits.propTypes = {
  title: PropTypes.string.isRequired,
  limits: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  loading: PropTypes.bool
};
